(function(){
"use strict";
if (typeof window.jnAltFormSuccess !== "undefined" && window.jnAltFormSuccess){
  var card = document.getElementById("JNBookingCard");
  var panel = document.getElementById("JNAltThankYou");
  var waLink = document.getElementById("JNAltThankYouWhatsApp");
  var raw = null;
  try { raw = sessionStorage.getItem("jnAltLastSubmission"); } catch(err){}
  var data = null;
  if (raw){ try { data = JSON.parse(raw); } catch(err){ data = null; } }

  if (panel){
    if (card) card.hidden = true;
    panel.hidden = false;
    panel.setAttribute("tabindex","-1");
    panel.focus();
  }

  if (waLink){
    var msg = "Hi Just Needles, I just submitted an alterations pickup request";
    if (data){
      if (data.name) msg += " — " + data.name;
      if (data.items && data.items.length){
        msg += ". Items: " + data.items.join(", ");
      }
      if (data.pickupDate || data.timeWindow){
        msg += ". Preferred pickup: " + (data.pickupDate || "date TBC") + (data.timeWindow ? " (" + data.timeWindow + ")" : "");
      }
      msg += ". I'd like to continue over WhatsApp.";
    } else {
      msg += ". I'd like to continue over WhatsApp.";
    }
    waLink.href = "https://wa.me/971585923467?text=" + encodeURIComponent(msg);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({event:"jn_alterations_lead", form_id:"JNAlterationsBooking"});

  try { sessionStorage.removeItem("jnAltLastSubmission"); } catch(err){}
}
})();
